// modules
import React, { FC } from 'react';
import { View } from '@upstox/upstox-ui';
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';
// typings
import { ModalType } from 'modules/PriceAlerts/typings';
// components
import PriceAlertsEmptyState from '../../../PriceAlertsEmptyState';
import CreatePriceAlertBody from './CreatePriceAlertBody/CreatePriceAlertBody';
import DeletePriceAlert from './DeletePriceAlert';
import ListPriceAlertBody from './PriceAlertList';
// styles
import * as css from './styles';

const PriceAlertsBody: FC = () => {
  const { modalType } = useStore('PriceAlertsStore');

  const renderModalBody = (type: ModalType) => {
    switch (type) {
      case 'Create':
        return <CreatePriceAlertBody />;
      case 'List':
        return <ListPriceAlertBody />;
      case 'Delete':
        return <DeletePriceAlert />;
      default:
        return <PriceAlertsEmptyState />;
    }
  };

  return <View css={css.alertbody}>{renderModalBody(modalType)}</View>;
};

export default observer(PriceAlertsBody);
